/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import MarkdownLayout from "components/MarkdownLayout";
import Button from "components/Button";
export const meta = {
  title: "FAQ",
  desc: "Answers to the most frequently asked questions."
};
const MDXLayout = ({children}) => _jsx(MarkdownLayout, {
  meta: meta,
  children: children
});
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    a: "a"
  }, props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "How is Raycast different to Spotlight, Alfred and other launchers?"
    }), "\n", _jsx(_components.p, {
      children: "Apple’s Spotlight is a search for apps, documents and files on your Mac as well as contextual information such as news or weather."
    }), "\n", _jsx(_components.p, {
      children: "Alfred is an app to search your Mac and the web with hotkeys, keywords, text expansions and more. Workflows are used to extend its functionality."
    }), "\n", _jsxs(_components.p, {
      children: ["Raycast provides a much richer feature set compared to those launchers. On top of searching local apps and files, it can be your clipboard manager, text expander, window manager, command palette for all apps and much more. Raycast provides much deeper and more native integrations to third party services. You can install extensions for Jira, GitHub, and Google Workspace, amongst others from the ", _jsx(_components.a, {
        href: "https://raycast.com/store",
        children: "Store"
      }), " and control them without ever opening a browser."]
    }), "\n", _jsx(_components.p, {
      children: "Raycast’s command line inspired user interface goes beyond searching data. List and detail views provide quick access to important information. Forms make it easy to create new content such as Jira issues, and the Action Panel is used to perform actions such as merging a GitHub pull request. We concentrate on providing a fluid UX throughout the app."
    }), "\n", _jsxs(_components.p, {
      children: ["Raycast can be extended to tailor the experience even further with ", _jsx(_components.a, {
        href: "https://github.com/raycast/script-commands",
        children: "Script Commands"
      }), " and custom extensions which can be built with our flexible ", _jsx(_components.a, {
        href: "https://developers.raycast.com",
        children: "API"
      }), ". You can share all that within teams or communities."]
    }), "\n", _jsx(_components.h2, {
      children: "What is the pricing for Raycast?"
    }), "\n", _jsxs(_components.p, {
      children: ["Raycast is free for personal use, and we would like to keep it that way. We are working on paid features for teams. You can find more info and FAQs about pricing ", _jsx(_components.a, {
        href: "https://www.raycast.com/pricing",
        children: "here"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      children: "What data does Raycast track?"
    }), "\n", _jsx(_components.p, {
      children: "We respect privacy and never collect any sensitive data. Some interactions in the app are tracked anonymously. For instance, we save usage statistics and error reports to constantly fix bugs and improve our product."
    }), "\n", _jsx(_components.h2, {
      children: "How does Raycast handle my data?"
    }), "\n", _jsx(_components.p, {
      children: "Raycast is a pure Mac citizen which doesn’t require a web account with a login. Sensitive data is encrypted and stored locally. When you export data to another Mac, we provide option to encrypt the backup as well."
    }), "\n", _jsx(_components.p, {
      children: "Extensions communicate with third party services directly and users sign in through the industry-standard OAuth protocol or use a personal access token. Credentials are stored securely in your Keychain."
    }), "\n", _jsx(_components.h2, {
      children: "Is Raycast available on Windows or Linux?"
    }), "\n", _jsx(_components.p, {
      children: "We want to nail the app for macOS first. Afterwards we will apply our learnings to the Windows and Linux clients."
    })]
  });
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
